import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function downloadClientImportTemplate() {
  const res = await axios.get(`${API}/clients/import/template`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  return res.data;
}

export async function createClientImportJob({ file, salon_id }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("salon_id", salon_id);
  const res = await axios.post(`${API}/clients/import/jobs`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function aiTranslateClientImport({ file, salon_id }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("salon_id", salon_id);
  const res = await axios.post(`${API}/clients/import/ai-translate`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function previewClientImportJob(jobId, payload) {
  const res = await axios.post(`${API}/clients/import/jobs/${jobId}/preview`, payload, {
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function listClientImportRows(jobId, { page = 1, limit = 25, filter = "all" } = {}) {
  const res = await axios.get(`${API}/clients/import/jobs/${jobId}/rows`, {
    params: { page, limit, filter },
    headers: authHeaders(),
  });
  return res.data;
}

export async function bulkUpdateClientImportRows(jobId, payload) {
  const res = await axios.post(
    `${API}/clients/import/jobs/${jobId}/rows/bulk-action`,
    payload,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
}

export async function commitClientImportJob(jobId, payload) {
  const res = await axios.post(`${API}/clients/import/jobs/${jobId}/commit`, payload, {
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function listImportJobs({ salon_id, page = 1, per_page = 10 }) {
  const res = await axios.get(`${API}/clients/import/jobs`, {
    params: { salon_id, page, per_page },
    headers: authHeaders(),
  });
  return res.data;
}

export async function getImportJob(jobId) {
  const res = await axios.get(`${API}/clients/import/jobs/${jobId}`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function rollbackImportJob(jobId) {
  const res = await axios.post(
    `${API}/clients/import/jobs/${jobId}/rollback`,
    {},
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}
